import React, { useEffect, useMemo, useState } from 'react';
import {
	Box,
	Button,
	MenuItem,
	Paper,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@mui/material';

import { useAppContext } from '../context/AppContext';
import { useToast } from '../context/ToastContext';

const normalizeRows = (response) => {
	if (Array.isArray(response)) return response;
	if (Array.isArray(response?.items)) return response.items;
	if (Array.isArray(response?.data)) return response.data;
	if (Array.isArray(response?.results)) return response.results;
	return [];
};

const Consumptions = () => {
	const { getConsumption , consumptions, applications, getApplications } = useAppContext();
	const { showError } = useToast();
	const [rows, setRows] = useState([]);
	const [loading, setLoading] = useState(false);
	const [page] = useState(1);
	const [pageSize] = useState(50);
	const [filters, setFilters] = useState({
		credential: '',
		application: '',
		from: '',
		to: '',
	});

	console.log('Applications from context: ', applications);
	const fetchConsumptions = async (activeFilters = filters) => {
		setLoading(true);
		try {
			const response = await getConsumption(
				activeFilters.credential || null,
				activeFilters.application || null,
				activeFilters.from || null,
				activeFilters.to || null,
				page,
				pageSize
			);
			setRows(normalizeRows(response));
		} catch (err) {
			setRows([]);
			showError('No se pudieron cargar consumptions desde API.');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchConsumptions();
		getApplications();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleFilterChange = (name) => (event) => {
		setFilters((prev) => ({ ...prev, [name]: event.target.value }));
	};

	const clearFilters = () => {
		const cleared = {
			credential: '',
			application: '',
			from: '',
			to: '',
		};
		setFilters(cleared);
		fetchConsumptions(cleared);
	};

	const credentialOptions = useMemo(() => {
		return [
			...new Set(
				consumptions
					.map((item) => item?.credential || item?.customer || item?.organization)
					.filter(Boolean)
			),
		];
	}, [consumptions]);

	console.log('Consumptions: ', consumptions);

	return (
		<Box>
			<Typography variant="h5" sx={{ mb: 2 }}>
				Consumptions
			</Typography>

			<Paper sx={{ p: 2, mb: 2 }}>
				<Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ mb: 2 }}>
					<TextField
							  label="Credential"
							  name="client_first_name"
							//   value={form.client_first_name}
							//   disabled={true}
							  onChange={handleFilterChange('credential')}
							  fullWidth
					/>
					<TextField
						label="Application"
						select
						value={filters.application}
						onChange={handleFilterChange('application')}
						fullWidth
					>
						<MenuItem value="">All</MenuItem>
						{applications.map((app) => {
							const appValue = typeof app === 'string' ? app : app?.name;
							const appKey = typeof app === 'string' ? app : app?.UanatacaBillingCode || '';

							if (!appValue) return null;
							
							return (
								<MenuItem key={appKey} value={appValue}>
									{appValue}
								</MenuItem>
							);
						})}
					</TextField>
					
				</Stack>

				<Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
					<TextField
						label="From"
						type="date"
						value={filters.from}
						onChange={handleFilterChange('from')}
						fullWidth
						InputLabelProps={{ shrink: true }}
					/>
					<TextField
						label="To"
						type="date"
						value={filters.to}
						onChange={handleFilterChange('to')}
						fullWidth
						InputLabelProps={{ shrink: true }}
					/>
					<Button
						variant="contained"
						onClick={() => fetchConsumptions()}
						sx={{ minWidth: 130 }}
						disabled={loading}
					>
						Search
					</Button>
					<Button variant="outlined" onClick={clearFilters} sx={{ minWidth: 130 }}>
						Clear Filters
					</Button>
				</Stack>
			</Paper>

			<Paper>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Date</TableCell>
								<TableCell>Credential</TableCell>
								<TableCell>Application</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{consumptions.map((row) => (
								<TableRow key={row.id} hover>
									<TableCell>{row.date}</TableCell>
									<TableCell>{row.customer}</TableCell>
									<TableCell>{row.product}</TableCell>
								</TableRow>
							))}

							{!loading && consumptions.length === 0 && (
								<TableRow>
									<TableCell colSpan={4} align="center">
										No consumptions found
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
		</Box>
	);
};

export default Consumptions;
